export default {
    "html": {
        "background": "#f0f2f5!important",
    },
    ".MuiButton-root": {
        "color": "#fff"
    },
    ".Mui-selected": {
        "color": "#000000!important",
        "background": "#1876c1!important"
    }
}
